import { Button } from "@volca/ui/components/ui/button";
import { DialogFooter } from "@volca/ui/components/ui/dialog";
import {
  Item,
  ItemContent,
  ItemDescription,
  ItemTitle,
} from "@volca/ui/components/ui/item";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { ApInvoiceItem } from "@/accounts-payable/types";
import {
  formatDollars,
  hasPricebookMatch,
  matchedPricebookItemLabel,
} from "@/accounts-payable/utils";

/**
 * The first step of a pick reached from a proposal about several lines
 * invoiced under one SKU. They are usually the same part, but a vendor's SKU
 * can name a product family with the size in the description, so the person
 * says which line the pick is for (the next step offers the rest).
 */
export const ProposalLineChooser = ({
  lines,
  onChoose,
  onClose,
}: {
  lines: ApInvoiceItem[];
  onChoose: (line: ApInvoiceItem) => void;
  onClose: () => void;
}) => (
  <>
    <Stack align="start" gap={2} className="w-full">
      <Text tone="muted">
        This proposal is about {lines.length} lines invoiced as {lines[0].sku}.
        Which one are you matching?
      </Text>
      <Stack className="w-full" align="start" gap={0} role="list">
        {lines.map((line) => (
          <Stack
            className="w-full"
            align="start"
            gap={4}
            key={line.id}
            role="listitem"
          >
            <Item
              size="xs"
              render={<button type="button" />}
              onClick={() => onChoose(line)}
              className="text-left"
            >
              <ItemContent className="gap-0">
                <ItemTitle className="line-clamp-none font-normal">
                  {line.quantity} × {line.description}
                </ItemTitle>
                <ItemDescription className="text-xs">
                  {formatDollars(line.unit_cost)}
                  {hasPricebookMatch(line) &&
                    ` · now ${matchedPricebookItemLabel(line)}`}
                </ItemDescription>
              </ItemContent>
            </Item>
          </Stack>
        ))}
      </Stack>
    </Stack>
    <DialogFooter className="flex-row justify-end">
      <Button variant="secondary" size="sm" onClick={onClose}>
        Cancel
      </Button>
    </DialogFooter>
  </>
);
